import { Box } from "@chakra-ui/react";
import { HStack, LargeButton, LARGEL_BUTTON_TYPE, Spinner, useResponsive } from "goi_common";

export default function RequestCompareFixedButton({
  handleSubmit,
  handleProceed,
  loading,
  disabled,
}: {
  handleSubmit: () => void;
  handleProceed: () => void;
  loading: boolean;
  disabled: boolean;
}) {
  const { isBiggerThanMd } = useResponsive();

  return (
    <HStack
      position="fixed"
      style={{
        bottom: 0,
        marginTop: "110px",
      }}
      width={isBiggerThanMd ? "480px" : "100%"}
      maxWidth={isBiggerThanMd ? "var(--global-max-width)" : "480px"}
    >
      <LargeButton
        buttonType={disabled ? LARGEL_BUTTON_TYPE.ORANGE_DISABLED : LARGEL_BUTTON_TYPE.ORANGE}
        disabled={disabled}
        borderRadius={"0 0 0 10px"}
        height={60}
        event={{
          newGtm: {
            path: "match_request",
            trigger_and_target: "footer_left-submit",
          },
        }}
        onClick={handleSubmit}
        className="subtitle_16_sb"
      >
        {loading ? <Spinner /> : "빠르게 알아보기"}
      </LargeButton>
      <LargeButton
        buttonType={disabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.PRIMARY}
        disabled={disabled}
        className="subtitle_16_sb"
        borderRadius={"0 0 10px 0"}
        height={60}
        event={{
          newGtm: {
            path: "match_request",
            trigger_and_target: "footer_right-submit",
          },
        }}
        onClick={handleProceed}
      >
        <Box display="flex">다음(상세 견적)</Box>
      </LargeButton>
    </HStack>
  );
}
